import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  span: {
    fontWeight: 600,
    textShadow: '1px 1px 2px rgba(0,0,0, 0.1)',
  },
}));
